import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
//import Modal from "components/common/modal";
import RoomTypeSelector from 'components/common/dropdowncomponents/roomtypeselector';

import Gauge from 'components/common/widgets/gauge';
import Bar from 'components/common/widgets/bar';
import LocationStats from 'components/common/widgets/locationstats';
import LocationBottomMenu from 'components/common/widgets/locationbottommenu';

class Widget extends React.Component {
    render() {
        return (
            <div className="grid-widget-card" >
                <div className="widget-card  box--shadow bg--white" ref={(e) => { this.widget = e }}  >
                    <div className="widget-card__header">
                        <div className="cursor--pointer " data-tooltip={this.props.node.info.name}>
                            <h3>{this.props.node.info.name}</h3>
                        </div>
                        {/*
                        <Modal
                            disableCloseButton={true}
                            ref={(elem) => { this.openInfoModal = elem }}
                            clickButton={() => { this.openInfoModal.close(); }}
                            header="Info Modal"
                            buttonText="Got it"
                            buttonClass="btn-success"
                            entry={
                                <div onClick={() => { this.openInfoModal.open() }} className="widget-card__header-info cursor--pointer">
                                    <img src="src/assets/icons/info.svg" alt="info-icon" />
                                </div>
                            }
                        >
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                        </Modal>
                        */}
                    </div>
                    <div className="widget-card__buttons" >
                        <div className="widget-card__buttons__location-select">
                            <RoomTypeSelector roomType={this.props.node.type} type={this.props.type} chooseType={this.props.getOverview} />
                        </div>
                        <div className="widget-card__buttons__quickaccess">
                            <Link className='widget-btn' data-tooltip="Stats"
                                to={'/statistic/' + this.props.node.id}>
                                <span className="font-icon icon-stats" />
                            </Link>
                            {this.props.node.info.hasfloorplan ?
                                <React.Fragment>
                                    <Link
                                        className='widget-btn'
                                        data-tooltip="Heatmap"
                                        to={'/heatmap/' + this.props.node.id}>
                                        <span className="font-icon icon-heatmap" />
                                    </Link>
                                    <Link
                                        className='widget-btn'
                                        data-tooltip="Live"
                                        to={'live/' + this.props.node.id}>
                                        <span className="font-icon icon-live" />
                                    </Link>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div className='widget-btn widget-btn_disabled' data-tooltip="Heatmap not available">
                                        <span className="font-icon icon-heatmap" />
                                    </div>
                                    <div className='widget-btn widget-btn_disabled' data-tooltip="Live not available">
                                        <span className="font-icon icon-live" />
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    </div>

                    {/*
                        arcParams={[x, y]}
                        x: radius
                        y: arcAngle

                    */}
                    <Gauge
                        label="Occupancy"
                        arcParams={[85, 110]}
                        values={this.props.gauge}
                    />
                    <Bar id={this.props.id} values={this.props.bar} />
                    <LocationStats stats={this.props.stats} />
                    <LocationBottomMenu
                        isComparisonWidget={this.props.isComparisonWidget}
                        faulty={this.props.stats.faulties} node={this.props.node}
                        redirectMaintenanceView={this.props.redirectMaintenanceView}
                        deleteWidget={this.props.deleteWidget}
                        tree={this.props.tree} editWidget={this.props.editWidget}
                        widget={this.widget}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.myAccountReducer.user,
        nodeMap: state.overviewReducer.nodeMap,
        overviewMap: state.statsReducer.overviewMap
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Widget);



// WEBPACK FOOTER //
// ./src/components/pages/overview/widgets/widget.jsx